import React from 'react';

import {TCustomColumn} from 'components/@common/widgets/custom-table/custom-table';

import {TForecastCommentsCore} from '../../model/types';
import {ForecastCommentsEditModal} from '../modal/edit-modal';

export const BASE_COLUMNS: TCustomColumn<TForecastCommentsCore>[] = [
    {
        dataIndex: 'id',
        key: 'id',
        title: '№',
        width: '50px',
        align: 'center',
        render: (_, forecastComments: TForecastCommentsCore, index: number) => (
            <ForecastCommentsEditModal
                forecastComments={forecastComments}
                value={index + 1}
            />
        ),
    },
    {dataIndex: 'taxPeriod', key: 'taxPeriod', title: 'Период', width: '150px', align: 'center'},
    {dataIndex: 'reportingYear', key: 'reportingYear', title: 'Год', width: '80px', align: 'center'},
];
